import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'

import {Card, CardActions, CardHeader, CardText, CardTitle} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
//import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
//import FlatButton from 'material-ui/FlatButton';
import RadioButtonUnchecked from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import RadioButtonChecked from 'material-ui/svg-icons/toggle/radio-button-checked';
import {grey100} from 'material-ui/styles/colors';

// Component 

const styles = {
 cardText : { fonttSize: '32px' },
 question : { minHeight: '100px', backgroundColor: grey100,},
 list : { paddingLeft: '32px', maxWidth: '300px', textAlign: 'center', margin: 'auto' },
}

const ListRadio = (id, answer) => ( id == answer ? <RadioButtonChecked /> : <RadioButtonUnchecked /> )


export const Question = ({id, text, count, answer, answers, onAnswer}) => (
  <Card>
    <CardTitle title={'Question '+(id+1)+' of '+count} />
    <CardTitle title={text} style={styles.question}/>
    <List style={styles.list}>
      {answers.map((text, aid) => {return <ListItem key={'p'+aid} primaryText={text} onTouchTap={() => onAnswer(id, aid+1, count)} leftIcon={ListRadio(aid+1, answer)} />})}
    </List>
  </Card>
)

Question.propTypes = {
}

// Container

const mapStateToProps = (state) => {
  return { id: state.questions.qid, text: state.questions.questions[state.questions.qid].text, answer: state.question[state.questions.qid], answers: state.questions.answers }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAnswer: (id, answer, count) => {
      dispatch(dispatch => {
        var at = (id + 1 < count) ? 'questions/NEXT' :  'questions/SUBMIT';
        dispatch(
          actions.save(id, answer)),
          setTimeout(() => dispatch({type: at}), 300)
      })
      //if (__DEV__) console.log('1');
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Question)



// WEBPACK FOOTER //
// ./src/question/components/Question.js